module.exports = __webpack_public_path__ + "media/images/apple-8f3676c4.jpg";